<template>
  <!-- Update Firmware -->
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Administrator Settings</h1>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div id="accordion" class="container-fluid">
        <div class="d-none d-sm-inline-flex">
          <ul class="nav configuration-nav" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                data-toggle="tab"
                href="#update_firmware"
                role="tab"
                ><i class="icon-refresh"></i> Update Firmware</a
              >
            </li>
            <!-- <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#change_password" role="tab"
                ><i class="icon-lock"></i> Change Password</a
              >
            </li> -->
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#notification_settings"
                role="tab"
                ><i class="icon-bell"></i> Notification Settings</a
              >
            </li>
            <li class="nav-item">
              <a class="nav-link" data-toggle="tab" href="#time_zone" role="tab"
                ><i class="icon-clock"></i> Time Zone</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                data-toggle="tab"
                href="#download_configurations"
                role="tab"
                ><i class="icon-download"></i> Download Configurations</a
              >
            </li>
          </ul>
        </div>

        <!-- Tab panes -->
        <div class="card">
          <div class="tab-content">
            <div class="overlay" v-if="is_loading">
              <img src="/assets/images/loader.svg" alt="" />
            </div>
            <div class="pt-3 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded collapsed"
                data-toggle="collapse"
                data-target="#update_firmware"
                aria-expanded="true"
              >
                <i class="icon-refresh"></i> Update Firmware
              </h3>
            </div>
            <div
              class="tab-pane default show"
              id="update_firmware"
              data-parent="#accordion"
            >
              <div id="firmwareUpdate" style="position: relative">
                <form
                  @submit.prevent="handleUpdateFirmwareSubmission()"
                  method="POST"
                  novalidate
                >
                  <div class="card-body update-firmware">
                    <div class="row">
                      <div class="col-md-8">
                        <h4 v-if="isAvailable > 0 && timeZoneValue.device_type !== 'x86_NO_WIFI'" class="card-common-title p-0 mb-2">
                          Note:
                        </h4>
                        <ul v-if="isAvailable > 0 && timeZoneValue.device_type !== 'x86_NO_WIFI'">
                          <li>
                            You may experience temporary loss in connectivity while the
                            system updates your Audra device
                          </li>
                          <li>
                            Once the update is complete, you might have to login to your
                            Audra local panel and re-configure your internet/WAN settings
                            from
                            <a href="http://local.audra.io/" target="_blank"
                              >local.audra.io</a
                            >.
                          </li>
                        </ul>

                        <div class="update-info py-3">
                          <p>
                            <i class="fas fa-circle"></i> Current Firmware Version<strong
                              id="current_version"
                            >
                              {{ pre.curVesion }}</strong
                            >
                          </p>
                          <p>
                            <i class="fas fa-circle"></i> New Firmware Version<strong
                              id="new_version"
                            >
                              {{ pre.newVesion }}</strong
                            >
                          </p>
                        </div>

                        <div class="error-message" v-if="pandingChangeLog > 0">
                          Please wait. The Firewall update is in processing.
                          <div class="firewall-progress my-3">
                            <div class="firewall-progress-percent" style="width: 35%">
                              35%
                            </div>
                          </div>
                        </div>

                        <h3 class="latest-firmware" v-else-if="isAvailable <= 0">
                          <i class="icon-update"></i> You already have the latest firmware
                        </h3>
                        <div v-else-if="isAvailable > 0 && timeZoneValue.device_type === 'x86_NO_WIFI'" class="release-notes">
                          <h3>Release Note – Audra Secure 400 (Version {{ pre.newVesion }})</h3>
                          <p>
                            We are pleased to announce the release of
                            <strong>Audra Secure 400 Firmware V{{ pre.newVesion }}</strong>, which includes several
                            performance and stability enhancements:
                          </p>

                          <h4>What’s New</h4>
                          <ol>
                            <li>
                              <strong>Local Portal PHP Updated</strong><br />
                              Upgraded PHP version to <b>8.2.12</b> for improved security and performance.
                            </li>
                            <li>
                              <strong>DDoS Protection Script Optimization</strong><br />
                              Enhanced DDoS handling to resolve intermittent browsing issues experienced on certain websites.
                            </li>
                            <li>
                              <strong>Session Log Application Optimization</strong><br />
                              Improved efficiency and responsiveness of the session logging module.
                            </li>
                            <li>
                              <strong>General Application Behaviour Improvements</strong><br />
                              Additional refinements to enhance overall system stability and performance.
                            </li>
                          </ol>

                          <h4>How to Update</h4>
                          <p>Please follow the steps below to safely complete the firmware upgrade:</p>
                          <ol>
                            <li>
                              <strong>Access the Local Portal</strong><br />
                              Connect any PC or laptop to the LAN network and log in to the local portal using the LAN gateway IP.
                            </li>

                            <li>
                              <strong>Initiate Firmware Update</strong>
                              <ul class="nested-list">
                                <li>Navigate to the Firmware Update menu.</li>
                                <li>
                                  A button labelled <strong>“Update Now”</strong> will appear. Click it to begin.
                                </li>
                                <li>
                                  The update process will take approximately 5–7 minutes, after which the device will reboot automatically.
                                </li>
                              </ul>
                            </li>

                            <li>
                              <strong>Do Not Interrupt the Update</strong><br />
                              Avoid rebooting or powering off the firewall during the update process.
                            </li>

                            <li>
                              <strong>Post-Update Internet Issue (If Any)</strong><br />
                              After the update, you may temporarily experience internet connectivity issues. To resolve this:
                              <ul class="nested-list">
                                <li>Log in again to the local portal using the LAN gateway IP.</li>
                                <li>
                                  Open the WAN Settings page and click <strong>Save</strong> (no changes required).
                                </li>
                                <li>
                                  Internet connectivity will be restored within 2–3 minutes.
                                </li>
                              </ul>
                            </li>
                          </ol>
                        </div>
                        <div v-else-if="isAvailable > 0">
                          <p class="mb-2">
                            From local.audra.io : Device Login >> (Being connected to
                            Audra)
                          </p>
                          <p>From local.audra.io > Device Login</p>
                          <ul>
                            <li>UPDATE FIRMWARE</li>
                            <li>Click update Now</li>
                            <li>Wait for the process to complete</li>
                          </ul>

                          <div class="youtube-link">
                            <a
                              target="blank"
                              href="https://www.youtube.com/watch?v=fg86AFPs9jA&list=PLe0hT-_4TF9G3y1c45N8p16M5DwvFos3A&index=9"
                            >
                              <i class="icon-youtube"></i> Watch how we do it
                            </a>
                          </div>
                        </div>
                        <button
                          v-if="1 == 0"
                          type="submit"
                          class="btn mt-3"
                          :disabled="isSubmit || disableSubmitButton"
                        >
                          {{ isSubmit ? "Please Wait..." : "Submit" }}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <!-- <div class="pt-2 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded"
                data-toggle="collapse"
                data-target="#change_password"
                aria-expanded="false"
              >
                <i class="icon-lock"></i> Change Password
              </h3>
            </div> -->

            <!-- <div class="tab-pane" id="change_password" data-parent="#accordion">
              <div id="users-add">
                <div class="overlay" v-if="is_loading">
                  <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                </div>

                <form
                  @submit.prevent="handleUpdatePasswordSubmission()"
                  method="POST"
                  novalidate
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h4
                          class="card-common-title p-0 mt-3 mb-4 d-flex align-items-center justify-content-between"
                        >
                          Change Password
                        </h4>

                        <div class="form-row">
                          <div class="form-group required col-md-12">
                            <label for="old_password" class="control-label"
                              >Current Password</label
                            >
                            <div class="password">
                              <input
                                autocomplete="off"
                                type="password"
                                id="old_password"
                                name="old_password"
                                v-model="inputs.old_password"
                                v-validate="'required'"
                                :class="{
                                  'has-error': errors.has('old_password'),
                                }"
                                class="form-control"
                                placeholder="Old Password"
                                :type="showOldPassword ? 'text' : 'password'"
                              />
                              <span class="password-toggle" @click="toggleOldPassword">
                                <i
                                  :class="{
                                    'icon-eye-off': showOldPassword,
                                    'icon-eye': !showOldPassword,
                                  }"
                                ></i>
                              </span>
                            </div>
                            <div
                              class="help text-danger"
                              v-show="errors.has('old_password')"
                            >
                              {{ errors.first("old_password") }}
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group required col-md-12">
                            <label for="password" class="control-label"
                              >New Password</label
                            >
                            <div class="password">
                              <input
                                autocomplete="off"
                                type="password"
                                id="password"
                                name="password"
                                v-model="inputs.password"
                                v-validate="'required|max:64|min:8'"
                                :class="{ 'has-error': errors.has('password') }"
                                class="form-control"
                                placeholder="New password"
                                :type="showPassword ? 'text' : 'password'"
                              />
                              <span class="password-toggle" @click="togglePassword">
                                <i
                                  :class="{
                                    'icon-eye-off': showPassword,
                                    'icon-eye': !showPassword,
                                  }"
                                ></i>
                              </span>
                            </div>

                            <div class="help text-danger" v-show="errors.has('password')">
                              {{ errors.first("password") }}
                            </div>
                          </div>
                        </div>
                        <div class="form-row">
                          <div class="form-group required col-md-12">
                            <label for="password_confirmation" class="control-label"
                              >Confirm Password</label
                            >
                            <div class="password">
                              <input
                                autocomplete="off"
                                type="password"
                                id="password_confirmation"
                                name="password_confirmation"
                                v-model="inputs.password_confirmation"
                                v-validate="'required'"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                :class="{
                                  'has-error': errors.has('password_confirmation'),
                                }"
                                class="form-control"
                                placeholder="Confirm password"
                              />
                              <span
                                class="password-toggle"
                                @click="toggleConfirmPassword"
                              >
                                <i
                                  :class="{
                                    'icon-eye-off': showConfirmPassword,
                                    'icon-eye': !showConfirmPassword,
                                  }"
                                ></i>
                              </span>
                            </div>

                            <div
                              class="help text-danger"
                              v-show="errors.has('password_confirmation')"
                            >
                              {{ errors.first("password_confirmation") }}
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                          <button type="submit" class="btn btn-site">
                            Change Password
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div> -->
            <div class="pt-2 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded"
                data-toggle="collapse"
                data-target="#notification_settings"
                aria-expanded="false"
              >
                <i class="icon-bell"></i> Notification Settings
              </h3>
            </div>
            <div class="tab-pane" id="notification_settings" data-parent="#accordion">
              <div id="NotificationSetting">
                <!-- <div class="overlay" v-if="is_loading">
                  <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                </div> -->
                <form
                  @submit.prevent="handleNotificationSettingSubmission()"
                  method="POST"
                  novalidate
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h4
                          class="card-common-title p-0 mt-3 mb-4 d-flex align-items-center justify-content-between"
                          v-if="organizationId == 1"
                        >
                          Notification
                          <router-link
                            class="btn btn-outline"
                            :to="{ name: 'NotificationSettingList' }"
                            ><i class="icon-text"></i> View All
                          </router-link>
                        </h4>
                        <div class="form-group">
                          <div class="d-flex align-items-center">
                            <div class="switch-row">
                              <label class="switch-label">Enable Notification</label>
                            </div>
                            <label class="switch ml-auto">
                              <input
                                type="checkbox"
                                name="notification_active"
                                v-model="notificationSettingValue.notification_active"
                                id="notification_active"
                                value="1"
                              />
                              <div class="slider round"></div>
                            </label>
                          </div>
                        </div>
                        <div class="form-group required">
                          <label class="control-label">Email</label>
                          <input
                            type="text"
                            id="recipients"
                            name="recipients"
                            v-model="notificationSettingValue.recipients"
                            class="form-control recipients"
                            v-bind:class="{
                              'has-error': errors.has('recipients'),
                            }"
                            v-validate="'required|email'"
                            placeholder="Recipients"
                          />
                          <div class="help text-danger" v-show="errors.has('recipients')">
                            {{ errors.first("recipients") }}
                          </div>
                        </div>
                        <div class="form-group required">
                          <label class="control-label">Notify Frequency</label>

                          <multiselect
                            v-model="notificationSettingValue.interval"
                            :options="Object.keys(pre.intervalList)"
                            :custom-label="(opt) => pre.intervalList[opt]"
                            placeholder="Select Interval"
                            :searchable="true"
                            :multiple="false"
                            id="interval"
                            v-bind:class="{
                              'has-error': errors.has('interval'),
                            }"
                            v-validate="'required'"
                            name="interval"
                          >
                          </multiselect>
                          <div class="help text-danger" v-show="errors.has('interval')">
                            {{ errors.first("interval") }}
                          </div>
                        </div>

                        <!-- <div class="form-group required">
                          <label class="control-label">Enable</label>

                          <multiselect
                            v-model="
                              notificationSettingValue.notification_active
                            "
                            :options="Object.keys(pre.optionList)"
                            :custom-label="(opt) => pre.optionList[opt]"
                            placeholder="Select Option"
                            :searchable="true"
                            :multiple="false"
                            id="notification_active"
                            v-bind:class="{
                              'has-error': errors.has('notification_active'),
                            }"
                            v-validate="'required'"
                            name="notification_active"
                          >
                          </multiselect>
                          <div
                            class="help text-danger"
                            v-show="errors.has('notification_active')"
                          >
                            {{ errors.first("notification_active") }}
                          </div>
                        </div> -->
                        <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                          <button type="submit" class="btn">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div class="pt-2 px-3 d-block d-sm-none mb-2">
              <h3
                class="accordion-heading border p-3 rounded"
                data-toggle="collapse"
                data-target="#time_zone"
                aria-expanded="false"
              >
                <i class="icon-clock"></i> Time Zone
              </h3>
            </div>
            <div class="tab-pane" id="time_zone" data-parent="#accordion">
              <div id="Account">
                <!-- <div class="overlay" v-if="is_loading">
                  <i class="fas fa-2x fa-sync-alt fa-spin"></i>
                </div> -->
                <form
                  @submit.prevent="handleTimeZoneSubmission()"
                  method="POST"
                  novalidate
                >
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6">
                        <h4
                          class="card-common-title p-0 mt-3 mb-4 d-flex align-items-center justify-content-between"
                          v-if="organizationId == 1"
                        >
                          Time Zone
                          <router-link
                            class="btn btn-outline"
                            :to="{ name: 'AccountList' }"
                            ><i class="icon-text"></i> View All
                          </router-link>
                        </h4>
                        <div class="form-group required">
                          <label class="control-label">Time Zone</label>

                          <multiselect
                            v-model="timeZoneValue.zone_time"
                            :options="Object.keys(pre.timeZoneList)"
                            :custom-label="(opt) => pre.timeZoneList[opt]"
                            placeholder="Select Time Zone"
                            :searchable="true"
                            :multiple="false"
                            id="zone_time"
                            v-bind:class="{
                              'has-error': errors.has('zone_time'),
                            }"
                            v-validate="'required'"
                            name="zone_time"
                          >
                          </multiselect>

                          <div class="help text-danger" v-show="errors.has('zone_time')">
                            {{ errors.first("zone_time") }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-end border-bottom pb-3 mb-3">
                          <button type="submit" class="btn">Update</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="pt-2 px-3 d-block d-sm-none mb-3">
              <h3
                class="accordion-heading border p-3 rounded"
                data-toggle="collapse"
                data-target="#download_configurations"
                aria-expanded="false"
              >
                <i class="icon-download"></i> Download Configurations
              </h3>
            </div>
            <div class="tab-pane" id="download_configurations" data-parent="#accordion">
              <div class="card-body download_configurations">
                <div>
                  <h4
                    class="card-common-title p-0 mb-4 d-flex align-items-center justify-content-between"
                  >
                    Configurations

                    <a @click.prevent="downloadConfig" class="btn btn-outline">
                      Download <i class="icon-download"></i>
                    </a>
                  </h4>
                  <ul>
                    <li>OSPF</li>
                    <li>PBR</li>
                    <li>ACL</li>
                    <li>Natting</li>
                    <li>GRE</li>
                    <li>VTI</li>
                    <li>IPSEC</li>
                    <li>IPSEC Transport</li>
                    <li>SNMP</li>
                    <li>DDNS</li>
                    <li>Port Forwading</li>
                    <li>Macbinding</li>
                    <li>Lan Settings</li>
                    <li>Preshared Key</li>
                    <li>VPN Pool</li>
                    <li>VPN User Profile</li>
                    <li>DDoS</li>
                    <li>VPN Passthrough</li>
                    <li>Spam Guard</li>
                    <li>Static Routing</li>
                    <li>Interface Configuration</li>
                    <li>Adv Port Forwarding</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { AuthAPI, CommonAPI } from "@/services/api";
import LocalStorage from "@/services/localStorage";
import { fileDownload } from "@/utils/CommonUtils";
import axios from "axios";
import { Notification } from "element-ui";

export default {
  name: "UpdateConfiguration",
  metaInfo: {
    title: "Administrator Settings | Dotlines",
  },
  components: {},
  data: () => ({
    organizationId: LocalStorage.get("organizationId"),
    userEmail: LocalStorage.get("userEmail"),
    isSelectorLoading: false,
    is_loading: false,
    old_password: "",
    password: "",
    password_confirmation: "",
    showOldPassword: false,
    showPassword: false,
    showConfirmPassword: false,
    isSubmit: false,
    params: {},
    value: {},
    notificationSettingValue: {},
    timeZoneValue: {},
    accountId: "",
    pre: {
      audraName: [],
      curVesion: "6.0.0",
      newVesion: "5.0.0",
      intervalList: {
        3600: "1 hour",
        10800: "3 hours",
        43200: "12 hours",
        86400: "Every Day",
        604800: "Every Week",
      },
      optionList: {
        1: "YES",
        0: "NO",
      },
      timeZoneList: {},
    },
    pandingChangeLog: 0,
    isAvailable: 0,
    zone_time: "",
    users: [],
    inputs: {},
  }),

  methods: {
    toggleOldPassword() {
      this.showOldPassword = !this.showOldPassword;
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    handleUpdateFirmwareSubmission() {
      const _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.isSubmit = true;
          _this.$swal
            .fire({
              title: "Are you sure to reboot?",
              text: "",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Reboot",
            })
            .then((result) => {
              if (result.isConfirmed) {
                _this.isSubmit = true;
                axios
                  .post("/addReboot", {
                    accountId: _this.accountId,
                  })
                  .then((response) => {
                    _this.$toaster.success(response.data.message);
                  })
                  .catch((error) => {
                    console.log(error);
                    _this.$swal.fire("Failed!", "failed to reboot.", "error");
                  })
                  .finally(() => {
                    _this.isSubmit = false;
                  });
              }
            });
        }
      });
    },

    handleNotificationSettingSubmission() {
      const _this = this;
      this.validateFields(["recipients", "interval"]).then((result) => {
        if (result) {
          _this.is_loading = true;
          const api_url =
            "/update-notification-settings/" + LocalStorage.get("accountId");

          axios({
            method: "PUT",
            url: api_url,
            data: _this.notificationSettingValue,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    handleTimeZoneSubmission() {
      const _this = this;
      this.validateFields(["zone_time"]).then((result) => {
        if (result) {
          _this.is_loading = true;
          const api_url = "/accounts/" + LocalStorage.get("accountId");
          const method = "PUT";

          axios({
            method: method,
            url: api_url,
            data: _this.timeZoneValue,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },

    handleUpdatePasswordSubmission() {
      const _this = this;
      this.validateFields(["old_password", "password", "password_confirmation"]).then(
        (result) => {
          if (result) {
            this.is_loading = true;
            AuthAPI.changePassword(this.inputs)
              .then((response) => {
                this.errors.clear();
                this.$toaster.success(response.message);
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.data);
              })
              .finally(() => {
                this.inputs = {};
                this.is_loading = false;
              });
          }
        }
      );
    },

    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      await CommonAPI.getAudraName(LocalStorage.get("accountId"))
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getNotificationDetail(LocalStorage.get("accountId"))
        .then((response) => {
          this.notificationSettingValue = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getTimeZone()
        .then((response) => {
          this.pre.timeZoneList = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await this.getTimeZoneDetail()
        .then((response) => {
          this.timeZoneValue = response.data;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.getVersionInfo();

      this.is_loading = false;

      this.updateLayout();
      $(window).resize(() => {
        this.updateLayout();
      });
    },
    updateLayout() {
      if ($(window).width() < 800) {
        const tab_pane = $(".tab-pane");
        tab_pane.removeClass("tab-pane active").addClass("collapse");
      } else {
        const tab_pane = $(".tab-pane");
        tab_pane.removeClass("collapse show").addClass("tab-pane");
        $(".default").addClass("active");
      }
    },

    getNotificationDetail: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/notification-settings-detail/" + LocalStorage.get("accountId");
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getVersionInfo: function () {
      axios
        .get("get-version-info", {
          params: {
            accountId: LocalStorage.get("accountId"),
            deviceType: LocalStorage.get("deviceType"),
          },
        })
        .then((response) => {
          const data = response.data.split("|");
          this.pre.curVesion = data[0];
          this.pre.newVesion = data[1];
          this.isAvailable = data[2];
          this.pandingChangeLog = data[3];
          //   console.local(data[2])
        })
        .catch((error) => {
          console.log("error " + error);
        })
        .finally(() => {});
    },

    getTimeZone: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/get-time-zone";
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    getTimeZoneDetail: function () {
      return new Promise((resolve, reject) => {
        const api_url = "/accounts/" + LocalStorage.get("accountId");
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            // console.log("error " + error);
            reject(error);
          });
      });
    },

    validateFields(fieldNames) {
      const fieldValidationPromises = [];

      fieldNames.forEach((fieldName) => {
        const promise = this.$validator.validate(fieldName);
        fieldValidationPromises.push(promise);
      });

      return Promise.all(fieldValidationPromises)
        .then((results) => {
          if (results.includes(false)) {
            return false;
          } else {
            return true;
          }
        })
        .catch((error) => {
          console.error("Validation error:", error);
          return false;
        });
    },
    downloadConfig() {
      // const api_url = '/downloadConfig/' + LocalStorage.get('accountId')

      axios
        .get("download-config", {
          params: {
            accountId: LocalStorage.get("accountId"),
          },
          responseType: "blob", // Important for handling binary data
        })
        .then((response) => {
          fileDownload(response.data, "config-file.zip");
        })
        .catch((error) => {
          console.error("There was an error downloading the file:", error);
        })
        .finally(() => {
          this.is_loading = false;
          Notification.success({
            title: "Download Completed",
            message: "Download operation completed successfully",
            type: "success",
          });
        });
    },
  },

  computed: {
    disableSubmitButton() {
      /* return this.pre.newVesion <= this.pre.curVesion; */
      return true;
    },
  },

  mounted() {
    this.initialize();
  },
};
</script>

<style scoped>
  .release-notes {
    line-height: 1.6;
    font-size: 14px;
    color: #333;
    text-align: left;
  }

  /* Main numbered list */
  .release-notes ol {
    margin: 10px 0;
    padding-left: 25px;
    list-style-type: decimal !important;
  }

  .release-notes ol li {
    margin-bottom: 15px;
  }

  /* Nested bullet points */
  .release-notes ul.nested-list {
    margin-top: 8px;
    padding-left: 20px;
    list-style-type: disc !important; /* Forces the bullet to appear */
  }

  .release-notes ul.nested-list li {
    margin-bottom: 5px;
    list-style: disc !important; /* Double-check for specific browsers */
    display: list-item; /* Ensures it acts like a list item */
  }
</style>
